export default __webpack_public_path__ + "static/media/rocket_anim_127.69688692.png";